"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getAlias;
var RESERVED_SEGMENTS = ['develop', 'staging', 'app'];
var SHOOTSTA_ALIAS = 'shootsta';

function getAlias() {
  var subdomainSegments = window.location.hostname.split('.');
  return RESERVED_SEGMENTS.includes(subdomainSegments[0]) ? SHOOTSTA_ALIAS : subdomainSegments[0];
}